<template>
  <div class="user-container">
      <div class='guest'>
        <div class="login" @click='toLogin'>登录/注册</div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },

  methods: {
    // toLogin() {
    //   var toURL = process.env.SSO_API
    //   var redirect = encodeURIComponent(process.env.SSO_REDIRECT)
    //   location.href = toURL + `?redirect=${ redirect }`
    // },
    toLogin() {
      var toURL = 'https://i.desmix.com/sso/auth/login'
      var redirect = encodeURIComponent(process.env.SSO_REDIRECT)
      location.href = toURL + `?from=nx_monitor&redirect=${ redirect }`
    }
  },
  computed:{
    
  }
};
</script>

<style scoped lang="less">
    .user-container{
        width:100%;
        height:100%;
        .guest{
          width:100%;
          height:100%;
          display:flex;
          justify-content: center;
          align-items:center;
          font-size:16px;
          color:#fff;
          .login {
            color:#fff;
            text-decoration: none;
            line-height: 50px;
            cursor: pointer;
          }
        }
        .user{
          width:100%;
          height:100%;
          display:flex;
          justify-content: space-evenly;
          align-items:center;
          font-size:18px;
          color:#fff;
          .img{
            width:18px;
            height:18px;
            img{
              width:100%;
              height:100%;
            }
          }
          .logout {
            cursor:pointer;
          }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/user.vue